import * as actionTypes from "./actionTypes";
import { rewardService } from "../../service";
import { errorHelper } from "../../common/helpers";
import { constants } from "../../common/constants";

export function getRewards({
  page = constants.GET_ALL_ITEMS,
  filter,
  reset,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_REWARDS });

      dispatch({ type: actionTypes.FETCH_REWARDS });

      const response = await rewardService.getAll(page, filter),
        data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_REWARDS_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_REWARDS_SUCCESS,
        payload: {
          rewards: data.rewards,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_REWARDS_FAILURE);
    }
  };
}

export function getCurrentGift() {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.FETCH_CURRENT_GIFT });

      const response = await rewardService.getCurrentGift(),
        data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_CURRENT_GIFT_FAILURE,
          payload: { error: data.message },
        });
        return;
      }

      dispatch({
        type: actionTypes.FETCH_CURRENT_GIFT_SUCCESS,
        payload: { gift: data.gift },
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_CURRENT_GIFT);
    }
  };
}

export function getServices() {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.FETCH_SERVICES });
      const response = await rewardService.getServices(),
        data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_SERVICES_FAILURE,
          payload: { error: data.message },
        });
        return;
      }

      dispatch({
        type: actionTypes.FETCH_SERVICES_SUCCESS,
        payload: { services: data.services },
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_SERVICES_FAILURE);
    }
  };
}

export function setCurrentGift(service_id: string, onSuccess) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.SET_CURRENT_GIFT });
      const response = await rewardService.setCurrentGift(service_id),
        data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.SET_CURRENT_GIFT_FAILURE,
        });
        return;
      }

      dispatch({
        type: actionTypes.SET_CURRENT_GIFT_SUCCESS,
        payload: {
          currentGift: data,
        },
      });

      onSuccess();
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.SET_CURRENT_GIFT_FAILURE);
    }
  };
}

export function resetRewards() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_REWARDS,
    });
  };
}

export function claimReward(reward_id, employee_id, onSuccess) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.CLAIM_REWARD });

      const response = await rewardService.claim(reward_id, employee_id),
        data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.CLAIM_REWARD_FAILURE,
          payload: { error: data.message },
        });
        return;
      }

      dispatch({
        type: actionTypes.RESET_CLAIM_REWARD,
        payload: {
          reward: data,
        },
      });

      dispatch({ type: actionTypes.RESET_CLAIM_REWARD });

      onSuccess();
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.CLAIM_REWARD_FAILURE);
    }
  };
}

export function resetClaimReward() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_CLAIM_REWARD,
    });
  };
}



// WEBPACK FOOTER //
// ./src/store/reward/actions.js